import { Injectable } from '@angular/core';

import { RolePermissionsService } from '../services/role-permissions.service';

@Injectable()
export class SuperAdminGuard {
	constructor(private permissionsService: RolePermissionsService) {}

	public canActivate(): boolean {
		return this.permissionsService.isSuperAdmin();
	}

	public canActivateChild(): boolean {
		return this.permissionsService.isSuperAdmin();
	}
}
